const greenCorridorsStaticData = [
  {
    id: "CORRIDOR1",
    name: "Горна Баня",
    coordinates: [
      {
        lat: 42.66691986970007,
        lng: 23.257959713480837,
      },
      {
        lat: 42.66559064114894,
        lng: 23.259552214668084,
      },
      {
        lat: 42.66209395991548,
        lng: 23.25041020532199,
      },
      {
        lat: 42.65974601666828,
        lng: 23.244070423497487,
      },
      {
        lat: 42.658142807304856,
        lng: 23.243730754277426,
      },
      {
        lat: 42.65710509943871,
        lng: 23.24323891019107,
      },
      {
        lat: 42.657397522554774,
        lng: 23.238823036197527,
      },
      {
        lat: 42.657053003194044,
        lng: 23.236812825492898,
      },
      {
        lat: 42.67098500255008,
        lng: 23.22045905627942,
      },
      {
        lat: 42.672821869775696,
        lng: 23.221385743667952,
      },
      {
        lat: 42.67437158411154,
        lng: 23.221195930001908,
      },
      {
        lat: 42.67645832618047,
        lng: 23.225499584506068,
      },
      {
        lat: 42.68725997046324,
        lng: 23.232419645981413,
      },
      {
        lat: 42.686339233171665,
        lng: 23.234398631403096,
      },
      {
        lat: 42.682592591939304,
        lng: 23.2418118070943,
      },
      {
        lat: 42.67929110050171,
        lng: 23.248144621950125,
      },
      {
        lat: 42.67796026993551,
        lng: 23.24921618964781,
      },
      {
        lat: 42.676873496154435,
        lng: 23.2496193604261,
      },
      {
        lat: 42.67344448705204,
        lng: 23.250116797901097,
      },
      {
        lat: 42.67019199716154,
        lng: 23.253856182725507,
      },
      {
        lat: 42.66691986970007,
        lng: 23.257959713480837,
      },
    ],
    tramLines: ["TM11"],
    trolleyLines: ["TBE73"],
    busLines: [],
  },
  {
    id: "CORRIDOR2",
    name: "Карпузица",
    coordinates: [
      {
        lat: 42.657475858523625,
        lng: 23.23658372639754,
      },
      {
        lat: 42.658935924007615,
        lng: 23.240603218915304,
      },
      {
        lat: 42.65949843063418,
        lng: 23.24400598163861,
      },
      {
        lat: 42.66589174102279,
        lng: 23.26150229061912,
      },
      {
        lat: 42.67200298238921,
        lng: 23.272353831702194,
      },
      {
        lat: 42.67931281572052,
        lng: 23.2846289502517,
      },
      {
        lat: 42.676029885799046,
        lng: 23.288709102653257,
      },
      {
        lat: 42.6740935566373,
        lng: 23.287178090421314,
      },
      {
        lat: 42.66949847252629,
        lng: 23.2806267076007,
      },
      {
        lat: 42.66465584881323,
        lng: 23.276242039637854,
      },
      {
        lat: 42.65712071857601,
        lng: 23.272293592696347,
      },
      {
        lat: 42.65949554494266,
        lng: 23.264911674076476,
      },
      {
        lat: 42.658620735255,
        lng: 23.264473066150018,
      },
      {
        lat: 42.65704764976163,
        lng: 23.264921379959706,
      },
      {
        lat: 42.655016827265754,
        lng: 23.265720635844218,
      },
      {
        lat: 42.65101736886498,
        lng: 23.266055213623126,
      },
      {
        lat: 42.64968269596052,
        lng: 23.265397268446264,
      },
      {
        lat: 42.64955010595139,
        lng: 23.26289170483543,
      },
      {
        lat: 42.6498607637424,
        lng: 23.260956961885938,
      },
      {
        lat: 42.64895802568576,
        lng: 23.256245886886497,
      },
      {
        lat: 42.648840638167414,
        lng: 23.252458822819104,
      },
      {
        lat: 42.6490778168992,
        lng: 23.25149579982391,
      },
      {
        lat: 42.65016957263431,
        lng: 23.24888323201079,
      },
      {
        lat: 42.64947715799848,
        lng: 23.245175099863673,
      },
      {
        lat: 42.65732156987462,
        lng: 23.236236650692902,
      },
      {
        lat: 42.657475858523625,
        lng: 23.23658372639754,
      },
    ],
    tramLines: ["TM11", "TM4"],
    trolleyLines: ["TB2", "TB9", "TBE73"],
    busLines: [],
  },
  {
    id: "CORRIDOR3",
    name: "Манастирски Ливади",
    coordinates: [
      {
        lat: 42.670502487981935,
        lng: 23.274431648105697,
      },
      {
        lat: 42.67008517513985,
        lng: 23.27550173774861,
      },
      {
        lat: 42.6683511131898,
        lng: 23.27930616893599,
      },
      {
        lat: 42.6656274757318,
        lng: 23.28716587270576,
      },
      {
        lat: 42.66524846365666,
        lng: 23.28821013402793,
      },
      {
        lat: 42.664424344471264,
        lng: 23.28987019525588,
      },
      {
        lat: 42.65877864330441,
        lng: 23.30098831088477,
      },
      {
        lat: 42.64844694077279,
        lng: 23.295071046261203,
      },
      {
        lat: 42.6536118361156,
        lng: 23.28272058985304,
      },
      {
        lat: 42.66013555037991,
        lng: 23.264567399625488,
      },
      {
        lat: 42.66416282427502,
        lng: 23.265670765853514,
      },
      {
        lat: 42.66810677344238,
        lng: 23.26587514210073,
      },
      {
        lat: 42.671853022403916,
        lng: 23.27242474054898,
      },
      {
        lat: 42.670502487981935,
        lng: 23.274431648105697,
      },
    ],
    tramLines: ["TM11", "TM4", "TM7"],
    trolleyLines: ["TB2", "TB7", "TB8", "TBE73", "TBE74"],
    busLines: [],
  },
];
export default greenCorridorsStaticData;
